import { Link as LinkLi } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { ROLES, pageUrls } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { hasRestrictedRole, hasValue, isInsuracePortalUser } from 'globalutils/fmUtils';
import PropTypes from 'prop-types';
import React, { lazy, useEffect } from 'react';
import { Link } from 'react-router-dom';
import TopActions from './TopActions';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Message = lazy(() => import(`globalcomponents/UI/Message/${layout}`));
const CheckBox = lazy(() => import(`globalcomponents/UI/Toggle/${layout}`));

const Component = ({
  theme,
  history,
  fleetCompanies,
  apiStatus,
  fetchFleetCompanies,
  callback,
  filterSuccess,
  Styled,
  i18n,
  topAction,
  pagination,
  setPagination,
  filters,
  setremoveData,
  removeData,
  columns,
}) => {
  useEffect(() => {
    setTableData(fleetCompanies.filteredList);
  }, [fleetCompanies.filteredList]);

  const isInsurancePortalUserRole = isInsuracePortalUser();
  const [tableData, setTableData] = React.useState(fleetCompanies.filteredList);

  const getSecurity = (item) => {
    const { green, yellow, red } = item.severity || {};
    const leftCurve = green ? 'green' : yellow ? 'yellow' : 'red';
    const rightCurve = red ? 'red' : yellow ? 'yellow' : 'green';

    return (
      <div className="severity-wrapper">
        <div
          style={{ width: `${green}%` }}
          className={`green-wrapper ${leftCurve === 'green' ? 'leftCurve addBorder' : ''} ${
            rightCurve === 'green' ? 'rightCurve' : ''
          }`}
        ></div>
        <div
          style={{ width: `${yellow}%` }}
          className={`yellow-wrapper ${yellow ? 'addBorder' : ''} ${leftCurve === 'yellow' ? 'leftCurve' : ''} ${
            rightCurve === 'yellow' ? 'rightCurve' : ''
          }`}
        ></div>
        <div
          style={{ width: `${red}%` }}
          className={`red-wrapper ${leftCurve === 'red' ? 'leftCurve' : ''} ${rightCurve === 'red' ? 'rightCurve' : ''}`}
        ></div>
      </div>
    );
  };

  const getFleetScoreClass = (score) => {
    if (score > 89) return 'text-green';
    if (score > 79) return 'text-yellow';
    if (score > 69) return 'text-orange';
    if (score > -1) return 'text-red';
    return '';
  };

  const generateRows = () => {
    const updatedList = tableData.map((item) => {
      return {
        ...item,
        severityGraph: item.severity ? (
          getSecurity(item)
        ) : (
          <div className="severity-wrapper">
            <div style={{ width: `100%` }} className={`green-wrapper leftCurve addBorder rightCurve`}></div>
          </div>
        ),
        fleetScoreEle: item?.fleetScore ? (
          <div className={getFleetScoreClass(item?.fleetScore)}>{item?.fleetScore}</div>
        ) : (
          'Not available'
        ),
        fleetScore: item?.fleetScore ? item?.fleetScore : 0,
        paymentStatus: <div style={{ width: '150px' }}>{item.paymentStatus}</div>,
        alerts: <Link to={pageUrls.fleetAlertsViewMore.replace(':id', item.id)}>View Alerts</Link>,
      };
    });
    return updatedList;
  };

  const hasUserListApiStatus = hasValue(apiStatus.status, 'api', fetchFleetCompanies);
  const information =
    hasUserListApiStatus && hasUserListApiStatus.errorMessage ? (
      <Message type="error" message={i18n.t(hasUserListApiStatus.errorMessage)} />
    ) : (
      i18n.t('common.tableEmptyMessage')
    );

  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      <Styled.Wrapper>
        {topAction && (
          <TopActions
            {...{
              history,
              fleetCompanies,
              callback,
              filterSuccess,
              Styled,
              i18n,
              setPagination,
              filters,
              setremoveData,
              removeData,
            }}
          />
        )}
        {isInsurancePortalUserRole && (
          <div className="renewalsFilter">
            <CheckBox
              label={i18n.t('onlyUpcomingRenewals')}
              type="NormalGrey"
              onClick={() => {
                history.push(
                  window.location.href.includes('upcomingRenewals') ? pageUrls.fleetCompanies : pageUrls.upcomingRenewalCompanies
                );
              }}
              checked={window.location.href.includes('upcomingRenewals')}
            />
          </div>
        )}
        <Styled.TableWrapper>
          <Table
            type="client"
            defaultSortBy={{ sortBy: 'name', order: 'asc' }}
            title=""
            columns={[...columns]}
            data={generateRows()}
            emptyMessage={information}
            itemsPerPage={10}
            actions={[
              ...(!hasRestrictedRole([ROLES.UNDER_WRITER])
                ? [
                    {
                      icon: (row) => {
                        return (
                          <LinkLi component={Link} to={pageUrls.cameraEvents.replace(':id', row.id)}>
                            <Icon src={mediaUrls?.camera} tooltip={'Camera Events'} />
                          </LinkLi>
                        );
                      },
                    },
                  ]
                : []),
              {
                icon: (row) => {
                  return row?.fleetScore && row?.fleetScore > -1 ? (
                    <LinkLi component={Link} to={pageUrls.newfleetScoreCardRedirect.replace(':id', row.id)}>
                      <Icon src={mediaUrls?.scoreCard} tooltip={'Score card'} />
                    </LinkLi>
                  ) : (
                    <Icon
                      src={mediaUrls?.scoreCard}
                      tooltip={'Score card'}
                      style={{ pointerEvents: 'none', opacity: 0.4 }}
                    />
                  );
                },
              },
              {
                icon: (row) => {
                  return (
                    <LinkLi component={Link} to={pageUrls.companiesEdit.replace(':id', row.id)}>
                      <Icon src={mediaUrls?.edit} tooltip={i18n.t('Edit')} />
                    </LinkLi>
                  );
                },
              },
            ]}
            pageinationReset={pagination}
            pagenationClicked={(e) => {
              setPagination(!e);
            }}
            i18n={i18n}
          />
        </Styled.TableWrapper>
      </Styled.Wrapper>
    </Box>
  );
};

Component.propTypes = {
  history: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
  fleetCompanies: PropTypes.object.isRequired,
  fetchUsers: PropTypes.func.isRequired,
  filterSuccess: PropTypes.func.isRequired,
};

export default Component;
